<script lang="ts">
  import { Stepper } from '@skeletonlabs/skeleton';
  import { ComponentStatus } from '$lib/components';
  import { scrollToTop } from '$lib/features/page';

  /** Required */
  export let actions: (() => void | Promise<void>)[];
  /** Default: `Confirmar` */
  export let submitLabel = 'Confirmar';

  let status: ComponentStatus = ComponentStatus.READY;
  $: isReady = status === ComponentStatus.READY;

  /**
   * Triggers matching function configured in actions array
   * @param e
   */
  async function onNext(e: { detail: { state: { current: number; total: number }; step: number } }): Promise<void> {
    scrollToTop();
    const action = actions[e.detail.state.current - 1];

    if (action) {
      await action();
    }
  }

  /**
   * Triggers last action
   * @param e
   */
  async function onComplete(): Promise<void> {
    if (!isReady) {
      return;
    }

    status = ComponentStatus.PROCESSING;

    scrollToTop();
    const action = actions.at(-1);

    await action();

    status = ComponentStatus.SUCCESS;
  }
</script>

{#key status}
  <Stepper
    start={isReady ? 0 : actions.length - 1}
    regionHeader="mt-10"
    stepTerm="Passo"
    regionContent="pt-2"
    buttonBackLabel="← Anterior"
    buttonNextLabel="Próximo →"
    buttonCompleteLabel={isReady ? submitLabel : 'Processando...'}
    buttonBack="variant-soft-surface"
    buttonNext="variant-filled"
    buttonComplete={isReady ? 'variant-filled-primary' : 'variant-soft-surface cursor-not-allowed'}
    on:next={onNext}
    on:complete={onComplete}
  >
    <slot />
  </Stepper>
{/key}
